import SiderAntd from 'antd/lib/layout/Sider';
import { Content as ContentAntd } from 'antd/lib/layout/layout';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Content = styled(ContentAntd)`
  width: 100%;
  min-height: 100%;
  padding: 45px 100px;
  background-color: ${COLOR.ALABASTER};
  overflow-y: scroll;
`;

export const Sider = styled(SiderAntd)`
  overflow: auto;
  background-color: ${COLOR.GREY_WHITE};
`;
